<template>
    <FormSection title="Preadmission Notes" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2">
                <Pagination ref="notesList" :page-changed="pageChangedCallback" :is-loading="isLoading">
                    <table class="table table-responsive-md border border-gray">
                        <thead>
                            <tr class="bg-table-header">
                                <th>Title</th>
                                <th>Date</th>
                                <th>User</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoading || isError || !hasData">
                            <!-- LOADING -->
                            <tr v-for="i of loadingCount" class="table-loading" v-if="isLoading">
                                <td v-for="i of columns">
                                    <span class="shimmer-loading"></span>
                                </td>
                            </tr>
                            <!-- EMPTY -->
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h3>No Preadmission Notes.</h3>
                                </td>
                            </tr>
                            <!-- ERROR -->
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Preadmission Notes" :try-again="resetList" />
                                </td>
                            </tr>
                        </tbody>
                        <template v-else>
                            <PreadmissionNotesRow
                                v-for="note of page.items"
                                :note="note"
                                :columns="columns"
                                :reset-list="resetList"
                            />
                        </template>
                    </table>
                </Pagination>
            </div>
        </template>
    </FormSection>
</template>

<script src="./PreadmissionNotes.ts"></script>
